<div class="details-row">
    <label fd-form-label>{{label}}:</label>
    <span [title]="tooltip" class="details-value">{{value}}</span>
</div>
